import { Pipe, PipeTransform } from '@angular/core';
import { DotNestedKeys } from '../helper/dot-nested-key.type';
import { some } from '../helper/sla-util.helper';

@Pipe({
    name: 'filter',
})
export class FilterPipe implements PipeTransform {

    public transform<T, D>(
        values: T[], field: DotNestedKeys<T> | null, value: D | D[],
        compare: ((val: T) => boolean) | 'equals' | 'not-equals' | 'smaller' | 'bigger' | 'smaller-equals' | 'bigger-equals' = 'equals',
    ): T[] {
        let findValues: D[];
        if (value instanceof Array) {
            findValues = value;
        } else {
            findValues = [ value ];
        }
        if (compare instanceof Function) {
            return values?.filter(compare);
        } else {
            return values?.filter((val: T) => some(val, field, findValues, compare));
        }
    }

}
